import React, { Component } from 'react';
import Notificacao from '../../components/Notificacao';
import { getLoggedInUser } from "../../helpers/authUtils";
import IconFile from '../../assets/svg/ic-actions-file.svg';
import PreLoaderWidget from '../../components/Loader';
import { FilaProcedimentoEnum, FilaProcedimentoRecusaEnum, PermissaoGeral } from '../../helpers/enums';
import moment from 'moment';
import LoadingFullScreen from '../../components/LoadingFullScreen';
import { onlyNumbers, sendWhatsappMessage } from '../../helpers/utils';
import SelectIcon from '../../gb-components/SelectIcon';
import { saveLogFila } from '../../Libs/filaProcedimentos';

export default class RecusaFila extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: getLoggedInUser(),
            notifition: false,
            loading: false,
            saving: false,
            obs: "",
            item: this.props.item,
            acoes: [
                { id: 1, descricao: FilaProcedimentoRecusaEnum.FimFila, },
                { id: 2, descricao: FilaProcedimentoRecusaEnum.Remover }
            ],
            acao: "",
        };
    }

    _salvar = async () => {
        const {
            obs,
            acao
        } = this.state;

        if (!obs || obs === "") {
            this.setState({
                notifition: true,
                msg: "Informe uma justificativa",
                nameclass: 'alert-danger',
                loading: false
            });
            return;
        }

        if (!acao || acao === "") {
            this.setState({
                notifition: true,
                msg: "Informe uma Ação",
                nameclass: 'alert-danger',
                loading: false
            });
            return;
        }
        this.setState({ saving: true });

        const item = this.props.item
        try {
            console.log(item.paciente.paciente)
            let phone = ""
            if (item.paciente.paciente.whatsapp || item.paciente.paciente.telefones) {
                phone = item.paciente.paciente.whatsapp ? item.paciente.paciente.whatsapp : `55${onlyNumbers(item.paciente.paciente.telefones)}`
            }

            // console.log(acao == 1)
            // console.log(acao)

            /*
            1 - Fim da fila
            2 - Remove da fila
            */
            if (acao == 1) {
                await item.ref.update({
                    status: FilaProcedimentoEnum.Aguardando,
                    data_fila: moment().format('YYYY-MM-DD HH:mm:ss'),
                    user_update: this.state.user.ref,
                    updated_at: moment().format('YYYY-MM-DD HH:mm:ss'),
                    data_agendamento: null,
                    hora_agendamento: null,
                })

                try {
                    await sendWhatsappMessage(
                        phone,
                        //`Pelo motivo de não comparecimento você foi direcionado para o final da fila. Procedimento: ${item.procedimento.descricao}`
                        `Você foi direcionado para o final da fila. Procedimento: ${item.procedimento.descricao}. Entre em contato para mais informações`
                    )
                } catch (error) {
                    console.log(error)
                }
            } else {
                await item.ref.update({
                    status: FilaProcedimentoEnum.Recusado,
                    data_recusa: moment().format('YYYY-MM-DD HH:mm:ss'),
                    user_recusa: this.state.user.ref,
                    user_update: this.state.user.ref,
                    updated_at: moment().format('YYYY-MM-DD HH:mm:ss'),
                    data_agendamento: null,
                    hora_agendamento: null,
                })

                try {
                    await sendWhatsappMessage(
                        phone,
                        `Seu procedimento: ${item.procedimento.descricao} foi recusado. Entre em contato para mais informações`
                    )
                } catch (error) {
                    console.log(error)
                }
            }

            // ISSO É FEITO PARA QUE A VARIAVEL ITEM TAMBÉM NÃO SEJA ALTERADA
            let data = { ...item }
            delete data.ref
            delete data.id
            await saveLogFila(item.id, data)

            this.setState({ saving: false })
            if (this.props.closeModal) {
                this.props.closeModal();
            }
        } catch (error) {
            console.log(error)
            this.setState({
                notifition: true,
                msg: "Algo deu errado, tente novamente ou entre em contato conosco",
                nameclass: 'alert-danger',
                saving: false
            });
        }
    };

    render() {
        if (getLoggedInUser().permissao.toString() !== PermissaoGeral.Paciente) {
            return (
                <React.Fragment>
                    {this.state.saving && <LoadingFullScreen></LoadingFullScreen>}

                    {this.state.loading ? (<div className="text-center"><PreLoaderWidget /> aguarde...</div>) : (

                        <div className="gb-form">
                            <div className="title">
                                Atenção!
                            </div>
                            <h5>Esta área é destinada para recusas de procedimento ou o não comparecimento do paciente na data marcada</h5>

                            {this.state.notifition ? (
                                <div className="pl-2 pr-2 m-1">
                                    <Notificacao
                                        msg={this.state.msg}
                                        nameclass={this.state.nameclass}
                                    />
                                </div>
                            ) : null}

                            <div className="row">
                                <div className="col-md-12">
                                    <SelectIcon
                                        icon={IconFile}
                                        data={this.state.acoes}
                                        placeholder="Ação"
                                        value={this.state.acao}
                                        change={event =>
                                            this.setState({ acao: event.target.value })
                                        }
                                        theme={2}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <label>Digite uma justificativa</label>
                                    <textarea
                                        style={{ width: "100%" }}
                                        onChange={v => this.setState({ obs: v.target.value })}
                                        rows={5}
                                    ></textarea>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <button onClick={() => this._salvar()} className="btn gb-button to-form full mt-3">
                                        Salvar
                                    </button>
                                </div>
                            </div>

                        </div>
                    )}
                </React.Fragment>
            );
        } else {
            return (<div className="alert alert-danger text-center">VOCÊ NÃO TEM PERMISSÃO DE ACESSO NESTA PÁGINA</div>)
        }
    }
}
